import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { AuthService } from '../user/auth.service';
import { TeamInvitePageModule } from 'src/app/pages/team-invite/team-invite.module';
import { AngularFireFunctions } from '@angular/fire/compat/functions';


@Injectable({
  providedIn: 'root'
})
export class OrderService {
  public orderListRef: firebase.firestore.CollectionReference;
  public orderRef: firebase.firestore.DocumentReference;
  public campaignRef: firebase.firestore.DocumentReference;

  constructor(
    private functions: AngularFireFunctions
  ) { }

  async createOrder(
    orderNum: string,
    campaignId: string,
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    order: {},
    address: {},
    subtotal: number,
    taxtotal: number,
    salestax: any,
    total: number,
    paid: boolean,
    teamId: string,
    pickup: boolean,
    payment: string,
    notes: string
  ): Promise<firebase.firestore.DocumentReference> {
    this.orderListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/orders`);
    this.campaignRef = firebase.firestore().doc(`/campaigns/${campaignId}`);
    return this.orderListRef.add({
      ordernum: orderNum,
      teamid: teamId,
      firstname: firstname,
      lastname: lastname,
      email: email,
      phone: phone,
      order: order,
      address: address,
      subtotal: subtotal,
      taxtotal: taxtotal,
      salestax: salestax,
      total: total,
      paid: paid,
      pickup: pickup,
      payment: payment,
      notes: notes,
      created: Date()
    }).then((docRef) => {
      const increaseSubTotal = firebase.firestore.FieldValue.increment(subtotal);
      const increaseTotal = firebase.firestore.FieldValue.increment(total);
      this.campaignRef.update({ subtotal: increaseSubTotal, total: increaseTotal });
      console.log("Document written with ID: ", docRef.id);
      return docRef;
    }).catch(error => {
      console.error(error);
      throw new Error(error);
    });
  }

  async createAuctionOrder(
    orderNum: string,
    campaignId: string,
    customer: any,
    customerid: string,
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    order: {},
    address: {},
    subtotal: number,
    taxtotal: number,
    salestax: any,
    total: number,
    paid: boolean,
    teamId: string,
    pickup: boolean,
    payment: string,
    notes: string
  ): Promise<firebase.firestore.DocumentReference> {
    this.orderListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/orders`);
    this.campaignRef = firebase.firestore().doc(`/campaigns/${campaignId}`);
    return this.orderListRef.add({
      ordernum: orderNum,
      teamid: teamId,
      customer: customer,
      customerid: customerid,
      firstname: firstname,
      lastname: lastname,
      email: email,
      phone: phone,
      order: order,
      address: address,
      subtotal: subtotal,
      taxtotal: taxtotal,
      salestax: salestax,
      total: total,
      paid: paid,
      pickup: pickup,
      payment: payment,
      notes: notes,
      created: Date()
    }).then((docRef) => {
      const increaseSubTotal = firebase.firestore.FieldValue.increment(subtotal);
      const increaseTotal = firebase.firestore.FieldValue.increment(total);
      this.campaignRef.update({ subtotal: increaseSubTotal, total: increaseTotal });
      console.log("Document written with ID: ", docRef.id);
      return docRef;
    }).catch(error => {
      console.error(error);
      throw new Error(error);
    });
  }


  async createWholesaleOrder(
    orderNum: string,
    campaignId: string,
    customer: any,
    customerid: string,
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    order: {},
    address: {},
    subtotal: number,
    taxtotal: number,
    salestax: any,
    total: number,
    paid: boolean,
    teamId: string,
    pickup: boolean,
    payment: string,
    notes: string
  ): Promise<firebase.firestore.DocumentReference> {
    this.orderListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/orders`);
    this.campaignRef = firebase.firestore().doc(`/campaigns/${campaignId}`);
    return this.orderListRef.add({
      ordernum: orderNum,
      teamid: teamId,
      customer: customer,
      customerid: customerid,
      firstname: firstname,
      lastname: lastname,
      email: email,
      phone: phone,
      order: order,
      address: address,
      subtotal: subtotal,
      taxtotal: taxtotal,
      salestax: salestax,
      total: total,
      paid: paid,
      pickup: pickup,
      payment: payment,
      notes: notes,
      created: Date()
    }).then((docRef) => {
      const increaseSubTotal = firebase.firestore.FieldValue.increment(subtotal);
      const increaseTotal = firebase.firestore.FieldValue.increment(total);
      this.campaignRef.update({ subtotal: increaseSubTotal, total: increaseTotal });
      console.log("Document written with ID: ", docRef.id);
      return docRef;
    }).catch(error => {
      console.error(error);
      throw new Error(error);
    });
  }

  async getCampaignOrders(campaignId: string): Promise<firebase.firestore.QuerySnapshot> {
    this.orderListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/orders`);
    return this.orderListRef.orderBy("created", "desc").get();
  }

  async getOrderDetail(orderNum: string): Promise<firebase.firestore.QuerySnapshot> {
    const order = firebase
      .firestore()
      .collectionGroup(`orders`)
      .where('ordernum', '==', orderNum);
    return order.get();
  }

  async getOrderCert(
    certId: string,
  ): Promise<firebase.firestore.DocumentSnapshot> {
    this.orderListRef = firebase
      .firestore()
      .collection(`certificate`);
    return this.orderListRef.doc(certId).get();
  }

  startPaymentIntentTest(amount, subtotal, stripeacctid, campaignId, orderNum, items, name, email, phone, test, type) {
    console.log("startPaymentIntentTest");
    console.log(test);
    console.log(type);
    console.log(amount);
    console.log(subtotal);
    console.log(stripeacctid);
    const callable = this.functions.httpsCallable('startPaymentIntentTest');
    const obs = callable({ amount, subtotal, stripeacctid, campaignId, orderNum, items, name, email, phone, test, type});
    return obs;
  }

  startPaymentIntentLive(amount, subtotal, stripeacctid, campaignId, orderNum, items, name, email, phone, test, type) {
    console.log("startPaymentIntentLive");
    console.log(test);
    console.log(type);
    console.log(amount);
    console.log(subtotal);
    console.log(stripeacctid);
    const callable = this.functions.httpsCallable('startPaymentIntentLive');
    const obs = callable({ amount, subtotal, stripeacctid, campaignId, orderNum, items, name, email, phone, test, type});
    return obs;
  }

  randomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
